import { Button, Modal, ModalProps } from '@payaca/ambrosia';
import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import useArchiveProject from '@/api/mutations/project/useArchiveProject';

const DeleteProjectModal: FC<Omit<ModalProps, 'title'>> = (props) => {
  const { ...rest } = props;
  const history = useHistory();
  const { projectId } = useParams<{ projectId: string }>();
  const { mutateAsync: archiveProjectMutation, isPending } =
    useArchiveProject();

  const handleDelete = async () => {
    await archiveProjectMutation(projectId);
    history.push('/deals');
  };

  return (
    <Modal title="Delete Project" {...rest}>
      <Modal.Body>
        <p>
          Deleting this Project will also delete/archive any Proposals,
          Invoices, Events, Tasks, Forms and Payments you have created under
          this Project.
        </p>
        <p className="mt-2 font-semibold">
          This action will not be reflected in any third-party integrations.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            disabled={isPending}
            isProcessing={isPending}
            colour={'red'}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteProjectModal;
